<template>
  <v-layout wrap fill-height>
    <v-flex xs12>
      <div class="calls pb-1">
        <v-tabs color="dark" fixed-tabs slider-color="cyan" grow id="callList">
          <v-tab key="activecall" to="/calls/active" v-if="callDetail.id">
            {{ $vuetify.t('$vuetify.calls.activeCall') }} ({{
              callDetail.call_remote_id
            }})
          </v-tab>
          <v-tab key="listcalls" to="/calls/list">
            {{ $vuetify.t('$vuetify.calls.availableCalls') }}
          </v-tab>
        </v-tabs>
        <router-view></router-view>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import CallsList from '@/components/CallsList.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Calls',
  components: {
    CallsList
  },
  computed: {
    ...mapGetters({
      callDetail: 'calls/getActiveCall'
    })
  }
}
</script>
<style scoped>
#callList {
  z-index: 4;
}
</style>
